module.exports = __webpack_public_path__ + "static/media/DN.30fa74e9.png";